export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_12.8d84a687.jpg";